export default __webpack_public_path__ + "static/cruiselogo_uncruise-645822bbfdadf319cedac581b352ba71.png";